module.exports = "<div class=\"content-overlay {{contentOverlay.cssClass}}\"\r\n     ng-class=\"{'is-open' : contentOverlay.isOpen}\"\r\n     >\r\n </div>\r\n"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/shop/components/contentoverlay/content-overlay-template.html
 ** module id = 913
 ** module chunks = 1
 **/